import styles from './SignupStep3.module.scss'
import { Button } from 'components/Button/Button'
import { useNavigate } from 'react-router-dom'


type Props = {
    onSubmit?: () => void,
    step?: number,
}

export function SignupStep3(props: Props) {
    const navigate = useNavigate()

    function handlePublic() {
        props.onSubmit()
    }

    function handleAnonymous() {
        navigate('/request')
    }

    return (
        <div className={styles['wrapper']}>
            <div className={styles['title']}>
                Your Drizzle page
            </div>
            <div className={styles['description']}>
                To claim donations — create your public page and share it in social media.
                <br />
                If you want to stay anonymous — stay.
                <br />
                You can public your page lately.
            </div>
            <div className={styles['buttons']}>
                <Button
                    size='m'
                    type='dark'
                    iconName='forward'
                    iconRight
                    onClick={handlePublic}
                >
                    Create public page
                </Button>
                <Button
                    size='m'
                    type='dark'
                    iconName='forward'
                    iconRight
                    onClick={handleAnonymous}
                >
                    Create anonymous profile
                </Button>
            </div>
        </div >
    );
}

